"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadarService = void 0;
const axios_1 = __importDefault(require("axios"));
const HttpServiceHelper_1 = require("./HttpServiceHelper");
class RadarService {
    constructor() {
        this.getConfig = async () => {
            const token = process.env.RADAR_KEY;
            const axiosConfig = {};
            if (token) {
                axiosConfig.headers = {
                    "Authorization": token
                };
            }
            return axiosConfig;
        };
        this.http = axios_1.default.create({
            timeout: 10000
        });
        // Add response formatters
        this.http.interceptors.response.use((response) => response, (error) => HttpServiceHelper_1.HttpServiceHelper.errorFormatter(error));
    }
    async getCoordinates(zipcode) {
        const axiosConfig = await this.getConfig();
        return this.http.get(`https://api.radar.io/v1/geocode/forward?query=${zipcode}`, axiosConfig)
            .then(response => {
            return response.data;
        });
    }
}
exports.RadarService = RadarService;
